import store from "src/store";

const baseUrl = "https://admin.xxx.airfind.com/";
const pageBuilderClientAdminUrl = "admin/page-builder?variant=x&page=y&clientName=z";

const isDebugLogEnabled = () => {
  const params = new URLSearchParams(window.location.search);
  return GLOBALS.ENV !== "production" && params.has("airFindDebugConsole") && params.get("airFindDebugConsole") === "true";
};

export const logAdminPageBuilderUrl = () => {
  if (!isDebugLogEnabled()) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const { page, clientName, variant } = store("config");
  const variantFromUrl = params.get("variant") || variant;

  let result = pageBuilderClientAdminUrl.replace("variant=x", `variant=${variantFromUrl}`)
      .replace("page=y", `page=${page}`)
      .replace("clientName=z", `clientName=${clientName}`);

  const url = new URL(window.location.href);
  const isLocal = url.port !== "" && url.hostname === "localhost";
  const env = GLOBALS.ENV;

  if (env === "development") {
    const adminLocalUrl = isLocal ? url.origin.replace("3100", "3000") : "";
    result = baseUrl.replace(isLocal ? "https://admin.xxx.airfind.com" : "xxx", isLocal ? adminLocalUrl : "dev") + result;
  } else if (env === "staging") {
    result = baseUrl.replace("xxx", "staging") + result;
  }

  console.log("Admin page builder link: ", result);
};


export const logSsr2Configs = ss2Data => {
  if (!isDebugLogEnabled() || !ss2Data) {
    return;
  }
  if (ss2Data) {
    const {
      active, name, sponsoredSearchResults2TestTraffic, overrideSponsoredSearchResults2AdUnitId,
      sponsoredSearchResults2AdUnitId, sponsoredSearchResults2SearchBarStyle, sponsoredSearchResults2TextAdsPosition,
      sponsoredSearchResults2ProductAds, sponsoredSearchResults2ProductAdsPosition, sponsoredSearchResults2D2STraffic,
      ssrDuplicateResultsBottom, bucket, bucketAllocation} = ss2Data;

    const bingConfiguration = {overrideSponsoredSearchResults2AdUnitId, sponsoredSearchResults2AdUnitId,
      sponsoredSearchResults2SearchBarStyle, sponsoredSearchResults2TextAdsPosition, sponsoredSearchResults2ProductAds,
      sponsoredSearchResults2ProductAdsPosition, sponsoredSearchResults2D2STraffic, ssrDuplicateResultsBottom, bucket, bucketAllocation };

    const mainConfiguration = { active, name, sponsoredSearchResults2TestTraffic };

    console.log("Sponsored Search Result 2 main configurations:");
    console.table([...Object.entries(mainConfiguration)]);
    console.log("Configurations:");
    console.table([...Object.entries(bingConfiguration)]);
  }
};

export const logFinalProvider = allocatedProvider => {
  if (isDebugLogEnabled() === true) {
    console.log("Allocated provider: ", allocatedProvider);
  }
};
